import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded'; // ----------------------------------------------------------------------

export var Select = function Select() {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: ExpandMoreRoundedIcon
      },
      styleOverrides: {
        root: {}
      }
    }
  };
};